import React from "react";
import { SxProps, Tabs, Tab, TabProps, styled, TabsProps } from "@mui/material";
import { Link, useLocation, matchPath } from "react-router";

interface TabType {
  to: string;
  matchingPaths?: string[];
  label: TabProps["label"];
  hide?: boolean;
}

interface TabbarProps extends Omit<TabsProps, "sx"> {
  sx?: SxProps;
  tabValue?: any;
  tabs: TabType[][];
}

// Tabbar with links handling otherwise you can use default MuiTabs
const Tabbar: React.FC<TabbarProps> = (props) => {
  const { tabs, ...otherProps } = props;
  const { pathname } = useLocation();
  const tabValue = React.useMemo(() => {
    let activeTab = "";
    tabs.forEach((tabGroup, index) => {
      tabGroup.forEach((tab) => {
        const _matchingPaths =
          tab.matchingPaths && tab.matchingPaths.length > 0 ? [tab.to, ...tab.matchingPaths] : [tab.to];
        _matchingPaths.forEach((path) => {
          const _matchPath = matchPath(path, pathname);
          if (_matchPath) activeTab = tab.to;
        });
      });
    });
    return activeTab;
  }, [pathname, tabs]);

  const isHidden = (tab: TabType): boolean => {
    return tab.hide ? tab.hide : false;
  };

  const showGroup = (tabs: TabType[]) => {
    return tabs.filter((x) => isHidden(x)).length < tabs.length;
  };

  const getShowTabs = (tabs: TabType[]) => {
    return tabs.filter((x) => !isHidden(x));
  };

  return (
    <StyledTabs value={tabValue} {...otherProps}>
      {tabs
        .filter((x) => showGroup(x))
        .map((tabGroup, index) =>
          getShowTabs(tabGroup).map((tab, tabIndex) => {
            const { to, matchingPaths, ...tabProps } = tab;
            const isGroupStart = index > 0 && tabIndex === 0;
            // @ts-ignore : component prop gets ignored with styled
            return <StyledTab component={Link} to={to} key={to} {...tabProps} value={to} isGroupStart={isGroupStart} />;
          })
        )}
    </StyledTabs>
  );
};

export default Tabbar;

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "none",
}));
const StyledTab = styled(Tab, { shouldForwardProp: (prop) => prop !== "isGroupStart" && prop !== "hide" })<{
  isGroupStart: boolean;
}>(({ theme, isGroupStart }) => ({
  ...(isGroupStart && {
    position: "relative",
    marginLeft: theme.spacing(3),
    overflow: "visible",
    "&:before": {
      position: "absolute",
      content: '""',
      height: 24,
      width: 1,
      left: theme.spacing(-2),
      background: theme.palette.backgroundAlpha.border,
    },
  }),
}));
